import {DataOptions} from "@/services/basic/metadata";
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from "@/components/WdiControls/WdiSelect";
import {FieldConfig, FieldConfigUtility} from "@/components/WdiBus/EcFieldConfig";
import {DatePicker, Form, Input} from "antd";
import {WdiInputNumber} from "@/components/WdiControls/WdiInputNumber";
import {Enum} from "@/enums/system";
import {Shop} from "@/services/mdm/shop";
import {EC} from "@/services/mdm/ec";
import {FieldProps, wdiCore, WdiModalProps} from "@/components/WdiControls";
import {Product} from "@/services/mdm/product";
import {ProFormInstance} from "@ant-design/pro-form";
import React from "react";
import {ProductAndIp} from "@/services/mdm/productAndIp";

//region > Product FieldConfig

export const PRODUCT_FULL_LEVELS = [
  Enum.ProductLevel.PRODUCT1, Enum.ProductLevel.PRODUCT2, Enum.ProductLevel.PRODUCT3, Enum.ProductLevel.PRODUCT4, Enum.ProductLevel.PRODUCT5
];
export const PRODUCT_FG_LEVELS = [
  Enum.ProductLevel.PRODUCT1, Enum.ProductLevel.PRODUCT2, Enum.ProductLevel.PRODUCT3, Enum.ProductLevel.PRODUCT4, Enum.ProductLevel.PRODUCT5
];
export const PRODUCT_BY_QTY_LEVELS = [
  Enum.ProductLevel.PRODUCT1, Enum.ProductLevel.PRODUCT2, Enum.ProductLevel.PRODUCT3, Enum.ProductLevel.PRODUCT4, Enum.ProductLevel.PRODUCT5
];
export const PRODUCT_BY_QTY_DISABLED_LEVELS = [
  Enum.ProductLevel.PRODUCT1, Enum.ProductLevel.PRODUCT2, Enum.ProductLevel.PRODUCT3
];

const productFields: Record<string, number> = {
  "productId1": Enum.ProductLevel.PRODUCT1,
  "productId2": Enum.ProductLevel.PRODUCT2,
  "productId3": Enum.ProductLevel.PRODUCT3,
  "productId4": Enum.ProductLevel.PRODUCT4,
  "productId5": Enum.ProductLevel.PRODUCT5,
};

export const getEcProductConfig = (ecFieldConfigs: Record<string, FieldConfig>) => {
  const productLevel: number[] = [];
  const productConf: FieldConfig = {contain: false, req: false};
  Object.keys(productFields).map(field => {
    if (ecFieldConfigs[field].contain) {
      productLevel.push(productFields[field]);
      productConf.contain = true;
    }
    if (ecFieldConfigs[field].req) {
      productConf.req = true;
    }
  });
  return {levels: productLevel, fieldCfg: productConf};
};

//endregion

export const convertEcFieldConfigs = async (ecExtendFieldsSa?: string, revExtendFieldsSa?: string) => {
  const extendFieldsSa = FieldConfigUtility.merge(ecExtendFieldsSa, revExtendFieldsSa);
  const ecFieldConfigs: Record<string, FieldConfig> = {};
  const response = await EC.getEcFieldConfigs()
  if (response && response.data) {
    response.data.map(item => {
      ecFieldConfigs[item.fieldKey] = FieldConfigUtility.get(item.bitValue, extendFieldsSa);
    });
  }
  return ecFieldConfigs;
}

export const ecFields: Record<string, any> = {
  shopId: {
    set: (item: API.FormSaDetailVo, formRef: React.RefObject<ProFormInstance>) => {
      if (item.shopId) {
        if (item.shopCode && item.shopName) {
          formRef.current?.setFieldsValue({
            shopId: {
              value: item.shopId,
              label: wdiCore.String.CodeOrName(item.shopCode, item.shopName)
            }
          });
        } else {
          Shop.get(item.shopId).then(response => {
            formRef.current?.setFieldsValue({
              shopId: {
                value: item.shopId,
                label: wdiCore.String.CodeOrName(response.data.shopCode, response.data.shopName)
              }
            });
          })
        }
      }
    },
    get: (value: any) => {
      return WdiSelectFormat.getvalue(value);
    }
  },
  displayTypeIds: {
    set: (item: API.FormSaDetailVo, formRef: React.RefObject<ProFormInstance>) => {
      if (item.displayTypeIds) {
        DataOptions.search({inValues: item.displayTypeIds, typeGroup: 103}).then(res => {
          if (res.data) {
            formRef.current?.setFieldsValue({
              displayTypeIds: res.data.map((item) => ({
                value: item.value,
                label: item.name
              }))
            });
          }
        })
      }
    },
    get: (value: any) => {
      return WdiSelectFormat.getvalue(value);
    }
  },
};

const shopId = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item name="shopId" label="门店" hidden={!props.fieldConfig.contain}
               rules={[{required: props.fieldConfig.req, message: '门店不能为空!'}]}>
      <WdiSelect
        {...{
          label: '门店',
          showSearch: true,
          remote: true,
          dataLoading: async (params) => {
            const response = await Shop.ajaxSearch(Object.assign({
              soldToCode: props.soldToCode,
              isActive: true
            }, params));
            return response.data.map((item) => ({value: item.shopId, label: item.codeOrName}));
          },
        }}
        reloadKey={props.soldToCode}
      />
    </Form.Item>
  ) : <></>
);
const quantitySellinForecast = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item
      name="quantitySellinForecast" label="预计出货销量(箱/大袋)"
      hidden={!props?.fieldConfig?.contain}
      rules={[{required: props?.fieldConfig?.req, message: '预计出货销量(箱/大袋)不能为空!'}]}>
      <WdiInputNumber min={0} readOnly={props.readOnly}/>
    </Form.Item>
  ) : <></>
);
const revenueSellinForecast = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item
      name="revenueSellinForecast" label="预计出货销售额"
      hidden={!props.fieldConfig.contain}
      rules={[{required: props.fieldConfig.req, message: '预估出货销售额不能为空!'}]}>
      <WdiInputNumber min={0} readOnly={props.readOnly}/>
    </Form.Item>
  ) : <></>
);
const quantityPosForecast = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item
      name="quantityPosForecast" label="预估POS销量(箱/大袋)"
      hidden={!props.fieldConfig.contain}
      rules={[{required: props.fieldConfig.req, message: '预估POS销量(箱/大袋)不能为空!'}]}>
      <WdiInputNumber min={0} readOnly={props.readOnly}/>
    </Form.Item>
  ) : <></>
);
const revenuePosForecast = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item
      name="revenuePosForecast" label="预估POS销售额"
      hidden={!props.fieldConfig.contain}
      rules={[{required: props.fieldConfig.req, message: '预估POS销售额不能为空!'}]}>
      <WdiInputNumber min={0} readOnly={props.readOnly}/>
    </Form.Item>
  ) : <></>
);
const activitySubjectId = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item name="activitySubjectId" label="活动主题" hidden={!props.fieldConfig.contain}
               rules={[{required: props.fieldConfig.req, message: '活动主题不能为空!'}]}>
      <WdiSelect {...{
        placeholder: "请选择活动主题",
        dataLoading: async (params) => {
          const response = await DataOptions.search(Object.assign({typeGroup: 121, isActive: true}, params));
          return response.data.map((item) => ({value: item.value, label: item.name}));
        }
      }} />
    </Form.Item>
  ) : <></>
);
const displayTypeIds = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item name="displayTypeIds" label="陈列形式" hidden={!props.fieldConfig.contain}
               rules={[{required: props.fieldConfig.req, message: '陈列形式不能为空!'}]}>
      <WdiSelect {...{
        mode: "multiple",
        placeholder: "请选择陈列形式",
        dataLoading: async (params) => {
          const response = await DataOptions.search(Object.assign({typeGroup: 103, isActive: true}, params));
          return response.data.map((item) => {
            return {value: item.value, label: item.name};
          });
        }
      }} />
    </Form.Item>
  ) : <></>
);
const displayQuantity = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item name="displayQuantity" label="陈列数量" hidden={!props.fieldConfig.contain}
               rules={[{required: props.fieldConfig.req, message: '陈列面积不能为空!'}]}>
      <WdiInputNumber min={0}/>
    </Form.Item>
  ) : <></>
);
const displayArea = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item name="displayArea" label="陈列面积" hidden={!props.fieldConfig.contain}
               rules={[{required: props.fieldConfig.req, message: '陈列面积不能为空!'}]}>
      <WdiInputNumber min={0}/>
    </Form.Item>
  ) : <></>
);
const priceSellinAfter = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item
      name="priceSellinAfter" label="促销供货价(箱/大袋)"
      hidden={!props?.fieldConfig?.contain}
      rules={[{required: props?.fieldConfig?.req, message: '促销供货价(箱/大袋)不能为空!'}]}>
      <WdiInputNumber min={0}/>
    </Form.Item>
  ) : <></>
);
const pricePosAfter = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item
      name="pricePosAfter" label="促销零售价(中包)"
      hidden={!props?.fieldConfig?.contain}
      rules={[{required: props?.fieldConfig?.req, message: "促销零售价(中包)不能为空"}]}>
      <WdiInputNumber min={0}/>
    </Form.Item>
  ) : <></>
);
const targetShopQuantity = (props: any) => (
  props?.fieldConfig ? (
    <Form.Item name="targetShopQuantity" label="目标门店数/场次" hidden={!props.fieldConfig.contain}
               rules={[{required: props.fieldConfig.req, message: '目标门店数/场次不能为空!'}]}>
      <WdiInputNumber min={0}/>
    </Form.Item>
  ) : <></>
);
const ip = (props: any) => (
  props?.fieldConfig && props.fieldConfig.contain ? (
    <Form.Item name="ip" label="IP" hidden={!props.fieldConfig.contain}
               rules={[{required: props.fieldConfig.req, message: 'IP不能为空!'}]}>
      <WdiSelect {...{
        placeholder: "请选择IP",
        dataLoading: async () => {
          if (props.productIds) {
            const response = await ProductAndIp.getByProductIds(props.productIds);
            return response.data.map((item) => ({value: item.ip, label: item.ip}));
          }
          return [];
        }
      }} reloadKey={props.productIds}/>
    </Form.Item>
  ) : <></>
);

const ecFieldItems: Record<string, (props: any) => React.ReactElement> = {
  "shopId": shopId,
  "quantitySellinForecast": quantitySellinForecast,
  "revenueSellinForecast": revenueSellinForecast,
  "quantityPosForecast": quantityPosForecast,
  "revenuePosForecast": revenuePosForecast,
  "activitySubjectId": activitySubjectId,
  "displayTypeIds": displayTypeIds,
  "displayQuantity": displayQuantity,
  "displayArea": displayArea,
  "priceSellinAfter": priceSellinAfter,
  "pricePosAfter": pricePosAfter,
  "targetShopQuantity": targetShopQuantity,
  "ip": ip,
};

export const buildEcFormItem = (key: string, props: any) => {
  if (props) {
    return ecFieldItems[key](props);
  }
  return null;
}

const formSaDetailIdOriginal = (props: any) => (
  <Form.Item name="formSaDetailIdOriginal" label="formSaDetailIdOriginal" hidden={true}>
    <Input readOnly/>
  </Form.Item>
);
const soldToName = (props: any) => (
  <Form.Item name="soldToName" label="客户">
    <Input readOnly/>
  </Form.Item>
);
const ecName = (props: any) => (
  <Form.Item name="ecName" label="费用项">
    <Input readOnly/>
  </Form.Item>
);
const revenueTypeName = (props: any) => (
  <Form.Item name="revenueTypeName" label="核算类型">
    <Input readOnly/>
  </Form.Item>
);
const boName = (props: any) => (
  <Form.Item name="boName" label="四级使用部门">
    <Input readOnly/>
  </Form.Item>
);
const activityDate = (props: any) => (
  <Form.Item name="activityDate" label="活动期间">
    <DatePicker.RangePicker format={'YYYY-MM-DD'}/>
  </Form.Item>
);
const supplyDate = (props: any) => (
  <Form.Item name="supplyDate" label="供货期间">
    <DatePicker.RangePicker format={'YYYY-MM-DD'}/>
  </Form.Item>
);
const productFgIds = (props: any) => (
  <Form.Item
    name="productFgIds" label="指定货补产品别" hidden={!isNeedProductFg(props.paymentMethodId)}
    rules={[{required: isNeedProductFg(props.paymentMethodId), message: '指定货补产品别编号不能为空!'}]}
  >
    <WdiTreeSelect {...{
      placeholder: "请选择产品别",
      defaultExpandKeys: props?.productFgIds ? [props?.productFgIds] : [],
      dataLoading: async (params) => {
        const response = await Product.searchAll(
          Object.assign({
            productLevels: PRODUCT_FG_LEVELS.join(),
            isActive: true,
          }, params)
        );
        const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
          textField: "codeOrName",
          valueField: "productId",
          id: "productId",
          pId: "parentId",
          level: "productLevel",
        }, response.data);
        return {treeData, dict};
      }
    }} />
  </Form.Item>
);
const remark = (props: any) => (
  <Form.Item name="remark" label="备注">
    <Input maxLength={2000}/>
  </Form.Item>
)

const fieldItems: Record<string, (props?: any) => React.ReactElement> = {
  "formSaDetailIdOriginal": formSaDetailIdOriginal,
  "soldToName": soldToName,
  "ecName": ecName,
  "revenueTypeName": revenueTypeName,
  "boName": boName,
  "activityDate": activityDate,
  "supplyDate": supplyDate,
  "productFgIds": productFgIds,
  "remark": remark,
};

export const buildFormItem = (key: string, props?: any) => {
  return fieldItems[key](props);
}

enum ModalEnums {
  NONE = 0,
  PREV = -1,
  IMPORT = -2
}

export const ModalTypeEnums = {
  ...ModalEnums,
  ...Enum.RevenueType
};

export const showFixedModal = (modalProps: WdiModalProps) => {
  return modalProps.visible && (modalProps.type === ModalTypeEnums.FIXED)
}
export const showSellinQtyModal = (modalProps: WdiModalProps) => {
  return modalProps.visible && modalProps.type && ((modalProps.type >= 101 && modalProps.type < 150) || (modalProps.type >= 201 && modalProps.type < 250))
}
export const showSellinRevModal = (modalProps: WdiModalProps) => {
  return modalProps.visible && modalProps.type && ((modalProps.type >= 151 && modalProps.type < 200) || (modalProps.type >= 251 && modalProps.type < 300))
}
export const showPosQtySupplyPriceModal = (modalProps: WdiModalProps) => {
  return modalProps.visible && (modalProps.type === ModalTypeEnums.POS_QTY_SUPPLY_PRICE || modalProps.type === ModalTypeEnums.POS_QTY_SUPPLY_PRICE_FIXED)
}
export const showPosQtySellinPriceModal = (modalProps: WdiModalProps) => {
  return modalProps.type === ModalTypeEnums.POS_QTY_SELLIN_PRICE || modalProps.type === ModalTypeEnums.POS_QTY_SELLIN_PRICE_FIXED
}
export const showPosRevModal = (modalProps: WdiModalProps) => {
  return modalProps.visible && (modalProps.type === ModalTypeEnums.POS_REV || modalProps.type === ModalTypeEnums.POS_REV_FIXED)
}

export const isNeedProductFg = (paymentMethodId: number) => {
  return paymentMethodId == Enum.PaymentMethod.FG_POOL || paymentMethodId == Enum.PaymentMethod.BUY_GIVE_POOL;
};

export const showCompany = (paymentMethodId: number) => {
  return paymentMethodId == Enum.PaymentMethod.TRANSFER || paymentMethodId == Enum.PaymentMethod.THIRD_PART
    || paymentMethodId == Enum.PaymentMethod.ACCOUNTING_ACCRUAL || paymentMethodId == Enum.PaymentMethod.ACCOUNTING_NO_ACCRUAL;
};
